import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from '../../../user/services/auth/auth.service';

@Injectable()
export class CanActivateLoginService implements CanActivate {
  constructor(private router: Router, private auth: AuthService) { }

  canActivate(): boolean {
    if (this.auth.isAuthenticated()) {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/layout/services/guards/can-activate-login.service.ts